import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import simpleFetch from "../../utils/simpleFetch";

class SchedulerInformations extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      workingDaysValue: {
        invoicesCreationDate: <FormattedMessage id="common.loading" />,
        invoicesGenerationDate: <FormattedMessage id="common.loading" />,
        invoicesDelayedGenerationDate: <FormattedMessage id="common.loading" />,
      },
    };

    this.setStateWorkingDaysReviewPhase = this.setStateWorkingDaysReviewPhase.bind(
      this
    );
  }

  componentDidMount() {
    this.setStateWorkingDaysReviewPhase();
  }

  setStateWorkingDaysReviewPhase() {
    simpleFetch("GET", `/v1/scheduler/scheduled-dates`, {}).then(
      (response) => {
        this.setState({ workingDaysValue: response });
      }
    );
  }

  render() {
    return (
      <div>
        <div className="justify-content">
          <div className="duo">
            <span>
              <FormattedMessage id="invoices.datatable.informations.beginingNextPeriod" />
            </span>
            <span className="text">
              {this.state.workingDaysValue["invoicesCreationDate"]}
            </span>
          </div>
          <div className="chevron">
            <span className="strong">{">>>"}</span>
          </div>
          <div className="duo">
            {!!this.props.activeBillingPeriods[0] && !this.props.activeBillingPeriods[0].isDelayed ? (
              <span>
                <FormattedMessage id="invoices.datatable.informations.finalInvoiceGeneration" />
                <span className="text">
                  {this.state.workingDaysValue["invoicesGenerationDate"]}
                </span>
              </span>
            ) : (
              <span>
                <FormattedMessage id="invoices.datatable.informations.finalInvoiceGenerationDelayed" />
                <span className="text">
                  {this.state.workingDaysValue["invoicesDelayedGenerationDate"]}
                </span>
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SchedulerInformations.propTypes = {
  activeBillingPeriods: PropTypes.array.isRequired,
};

export default SchedulerInformations;



// WEBPACK FOOTER //
// ./src/utils/SchedulerInformations.js